import React from 'react'
import {  Button } from 'antd';
import DeleteConfirm from '../../../../components/Modal/DeleteConfirm'
const RenewPlan = ({ renewalDate }) => {

    


    const renderButton = () => {
        return <DeleteConfirm
            type="unsubscribePlane"
            method="PUT"
            selectedItem={JSON.parse(localStorage.getItem('userInfo'))}
            buttonName="Yes"
            title="Are you sure you want to unsubscribe this plan?"
            content=""
            Icon={<Button style={{color : 'red', border : '1px solid red', background : 'white'}} danger className="gx-pt-0 gx-mb-0" htmlType="button">Unsubscribe</Button>}
        />

    }

    return (
        <div>
            
            {renderButton()}
        </div>
    )
}

export default RenewPlan
